import { Box, Grid, Typography, useMediaQuery } from "@mui/material";

function ModuleSection({ title, onClick, className, selectedModule, itemKey }) {
  const md = useMediaQuery("(max-width:450px)");
  return (
    <Grid
      display={"grid"}
      justifyItems="center"
      minWidth={md ? "120px" : "unset"}
    >
      <Box
        sx={{ fontFamily: "icomoon !important", cursor: "pointer" }}
        className={className}
        color={selectedModule === itemKey ? "var(--emr-darkblue)" : "#909090"}
        mt="40px"
        mb="10px"
        fontSize="30px"
        onClick={onClick}
      />
      <Typography
        width="100%"
        textAlign="center"
        color={selectedModule === itemKey ? "var(--emr-darkblue)" : "#909090"}
        fontWeight="bold"
        fontSize="20px"
        sx={{ cursor: "pointer" }}
        onClick={onClick}
      >
        {title}
      </Typography>
    </Grid>
  );
}

export default ModuleSection;
